import React from 'react'
import styled from 'styled-components'
import { breakpoint } from '../../shared/theme'

const Wrapper = styled.article`
	position: relative;

	&::before {
		content: '';
		position: relative;
		display: block;
		width: 100%;
		padding-top: calc(((500 / 375) * 100%) - 215px);

		@media ${breakpoint('tablet')} {
			padding-top: calc(((750 / 1920) * 100%) - 112px);
		}
	}
`

const postPageWrap = ({ children }) => {
	return <Wrapper>{children}</Wrapper>
}

export default postPageWrap
